import React from 'react'
import { useState, useEffect } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';

import './Sales.css'
import { useTranslation } from "react-i18next";

// 元→円換算は仕様の exchange-rate（1pt=0.043元 ＝ 1円=0.043元）を使う: 円 = 元 / rate。
// rate はサーバ応答(data.rate, rate_snapshot)を使用。取得不可時のフォールバックのみ env/固定値。
const PT_CNY_RATE_FALLBACK = Number(process.env.REACT_APP_PT_CNY_RATE) || 0.043;

const Sales = () => {
  const { t } = useTranslation();

  const [salesList, setSalesList] = useState([]);
  const [date, setDate] = useState(new Date());
  const [yearLabel, setYearLabel] = useState('');
  const [sales, setSales] = useState(0);
  const [cashSales, setCashSales] = useState(0); // v2 現金純売上(元)
  const [cashJpy, setCashJpy] = useState(0); // 円換算(参考)
  const [rate, setRate] = useState(PT_CNY_RATE_FALLBACK); // 元→円換算用 1pt=rate元
  const [salesCharge, setSalesCharge] = useState(0);
  const [charge, setCharge] = useState(0);
  const [profit, setProfit] = useState(0);
  const [give, setGive] = useState(0);

  const prevYearButton = (e) => {
    setDate(new Date(date.getFullYear() - 1, date.getMonth(), date.getDate()));
  }

  const nextYearButton = (e) => {
    setDate(new Date(date.getFullYear() + 1, date.getMonth(), date.getDate()));
  }

  const [loadList, setLoadList] = useState(false)

  const getSales = () => {
    setLoadList(true);
    setSales('-');
    setCashSales('-');
    setCashJpy('-');
    setSalesCharge('-');

    let currentDate = date;
    let year = currentDate.getFullYear();
    
    setYearLabel(year);

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/sales?year=${year}`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
        'Content-Type': 'application/json'
      },
      credentials: 'include',
    })
    .then(response => response.json())
    .then(data => {
      if(!data.errors) {
        setSales(
          (Number(data.yearly_total.total_get_points) + Number(data.yearly_total.total_shop_payment_points))
            .toLocaleString('ja-JP'));
        const netCny = Number(data.yearly_total.total_cash_sales_cny || 0) - Number(data.yearly_total.total_cash_refund_cny || 0);
        const curRate = Number(data.rate) || PT_CNY_RATE_FALLBACK;
        setRate(curRate);
        setCashSales(netCny.toLocaleString('ja-JP', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setCashJpy(Math.round(netCny / curRate).toLocaleString('ja-JP'));
        setGive(
          Number(data.yearly_total.total_use_points).toLocaleString('ja-JP')
        )

        setProfit(
          Number(
            Number(data.yearly_total.total_refund_points)
            + Number(data.yearly_total.total_give_points)
          ).toLocaleString('ja-JP')
        )

        setSalesList(data.sales);
        setLoadList(false)
      } else {
        alert(Object.values(data.errors)[0]);
      }
    })
    .catch(error => {
      alert(t('sales.error'));
    });
  }
  
  useEffect(() => {
    getSales();
  }, [date]);

  const CreateSalesList = () => {
    return salesList.map((sales, index) => {
      sales.ranking = index + 1;
      return (
        <Tr key={index} sales={sales} rate={rate} />
      )
    })
  }
    


  return (
    <>
      <Header />
      <SideMenu />
      <div className="sales">
        <div className="sales-title">{t('sales.title')}</div>
        <div className='clearfix'></div>
        <div className="sales-search">
          <div className="sales-search-paging">
            <button className="sales-search-paging-prev-button sales-search-paging-button" onClick={prevYearButton}>{t('sales.prev')}</button>
            <div className="sales-summary">
              <div className="sales-summary-item-main">
                <div className="sales-summary-item-main-title">
                  {yearLabel}{t('sales.year')}<br />
                  {t('sales.cash_sales')}
                </div>
                <div className="sales-summary-item-main-value">{cashSales} 元</div>
                <div className="sales-summary-item-main-sub">≈ ¥{cashJpy}（{t('sales.jpy_ref')}）</div>
              </div>
              <div className="sales-summary-item-left">
              <div className="sales-summary-item-left-title">{t('sales.point2')}</div>
                <div className="sales-summary-item-left-value">{give} pt</div>
              </div>
              <div className="sales-summary-item-right">
              <div className="sales-summary-item-right-title">{t('sales.point3')}</div>
                <div className="sales-summary-item-right-value">{profit} pt</div>
              </div>
            </div>
            <button className="sales-search-paging-next-button sales-search-paging-button" onClick={nextYearButton}>{t('sales.next')}</button>
          </div>
        </div>
        <div className="sales-content">
          <div className="sales-content-table">
            <table className="sales-content-table">
              <thead>
                <tr>
                  <th></th>
                  <th>{t('sales.cash_col')}</th>
                  <th>{t('sales.cash_col_jpy')}</th>
                  <th>{t('sales.card_exchange')}</th>
                  <th>{t('sales.point6')}</th>
                  <th>{t('sales.point8')}</th>
                  <th>{t('sales.point5')}</th>
                </tr>
              </thead>
              <tbody>
                {!loadList ?
                  <CreateSalesList />
                  :
                  <>
                    <tr>
                      <td colSpan="7" className="sales-content-table-loading">
                        {t('common.loading')}
                      </td>
                    </tr>
                  </>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default Sales